<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <app-link
        @mouseenter.native="updateIcon(true)"
        @mouseleave.native="updateIcon(false)"
        v-if="onlyOneChild.meta"
        :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown': !isNest}">
          <item :icon="iconName" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <item
        slot="title"
        @mouseenter.native="updateIcon(true)"
        @mouseleave.native="updateIcon(false)"
        :icon="iconName"
        :title="item.meta.title" />
      <template v-for="cItem in item.children">
        <div v-if="!cItem.hidden" :key="`${item.path}/${cItem.path}`">
          <el-submenu
            v-if="cItem.children && cItem.children.length > 0"
            :index="`${item.path}/${cItem.path}`"
            :key="`${item.path}/${cItem.path}`"
            popper-append-to-body>
            <item slot="title" :title="cItem.meta.title" />
            <el-menu-item
              v-for="gItem in cItem.children"
              class="sub-menu-item"
              :key="`${item.path}/${cItem.path}/${gItem.path}`"
              :index="`${item.path}/${cItem.path}/${gItem.path}`"
            >{{ gItem.meta.title }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item
            v-else
            class="sub-menu-item"
            :key="`${item.path}/${cItem.path}`"
            :index="`${item.path}/${cItem.path}`"
          >{{ cItem.meta.title }}
          </el-menu-item>
        </div>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from './Item.vue';
import AppLink from './Link.vue';
import FixiOSBug from './FixiOSBug';

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      onlyOneChild: {},
      isHover: false,
    };
  },
  computed: {
    iconName() {
      return this.chooseIcon(this.item, this.$route.path, this.isHover);
    },
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        }
        this.onlyOneChild = item;
        return true;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
        return true;
      }
      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    chooseIcon(item, path, hover) {
      if (!item.children) return false;
      // 选中菜单图标变成蓝色
      const dirs = [];
      item.children.forEach((obj) => {
        if (obj.children && obj.children.length > 0) {
          obj.children.forEach((child) => {
            dirs.push(`${item.path}/${obj.path}/${child.path}`);
          });
        } else {
          dirs.push(`${item.path}/${obj.path}`);
        }
      });
      if (dirs.includes(path) || hover) {
        // 当前菜单下有一项子菜单被选中，返回activeIcon或icon
        return item.meta ? (item.meta.activeIcon || item.meta.icon) : '';
      }
      return item.meta ? item.meta.icon : '';
    },
    updateIcon(isHover) {
      this.isHover = isHover;
    },
  },
};
</script>
<style lang="scss">
.menu-wrapper {
  .el-menu-item {
    padding-left: 20px !important;
    font-size: 14px;

    i {
      margin-right: 20px;
      font-size: 20px;
    }
  }

  .sub-menu-item {
    padding-left: 64px !important;
    font-size: 16px;
  }

  .el-submenu .el-submenu .el-submenu__title {
    padding-left: 64px !important;
    font-size: 16px;
  }
}
</style>
